import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const AgentName = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s'-]+$/;
    if (value.length < 1) return 'Please enter the agent name';
    if (!regex.test(value)) return 'Please enter a valid name';

    return true;
  };

  return (
    <ValidatingInput
      label="Agent name"
      name="agentName"
      placeholder="Agent name"
      validate={validate}
      {...props}
    />
  );
};
